/* eslint-disable */
export default {
  sureToDeleteVoiceMail: 'Are you sure you want to delete this voicemail?',
  sureToDeleteFax: 'Are you sure you want to delete this fax?',
  doNotAskAgain: 'Don’t ask me again',
} as const;

// @key: @#@"sureToDeleteVoiceMail"@#@ @source: @#@"Are you sure you want to delete this voicemail?"@#@
// @key: @#@"sureToDeleteFax"@#@ @source: @#@"Are you sure you want to delete this fax?"@#@
// @key: @#@"doNotAskAgain"@#@ @source: @#@"Don't ask me again"@#@
